<template>
  <div>
    <!--    <el-button @click="addInput" type="primary" style="margin-top: 10px;margin-bottom: 10px;">新增</el-button><span></span>-->
    <!--    <div v-for="(item, index) in val" :key="index">-->
    <!--      <el-col :span="16">-->
    <!--      <el-input-->
    <!--          v-model="val[index]"-->
    <!--          type="text"-->
    <!--          placeholder="请输入科研方向"-->
    <!--      ></el-input>-->
    <!--      </el-col>-->
    <!--      <el-button @click="deleteInput(index)" style="margin-left: 10px;">x</el-button>-->
    <!--    </div>-->
    <el-tag
      v-for="tag in val"
      :key="tag"
      closable
      type="info"
      :disable-transitions="false"
      @close="handleClose(tag)"
    >
      {{ tag }}
    </el-tag>
    <el-input
      v-if="inputVisible"
      ref="saveTagInput"
      v-model="inputValue"
      class="input-new-tag"
      size="small"
      @keyup.enter.native="handleInputConfirm"
      @blur="handleInputConfirm"
    >
    </el-input>
    <el-button
      v-else
      class="button-new-tag"
      size="small"
      type="primary"
      @click="showInput"
      >+添加</el-button
    >
  </div>
</template>
<script>
export default {
  name: "ResearchDialog",
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      val: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  watch: {
    value: {
      handler(v) {
        this.val = [];
        if (v && v.length > 0) {
          this.val = v.split(/[，,]/g);
        }
      },
      immediate: true,
    },
    val(v) {
      this.$emit("change", v.join(",") || "");
    },
  },
  mounted() {},
  methods: {
    handleClose(tag) {
      if (this.val.length === 1) {
        this.$message.warning("请至少填写一个科研方向！");
        return;
      }
      this.val.splice(this.val.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.val.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
  },
};
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
